import React from "react"
import { Card, CardBody, CardHeader } from "reactstrap"
import { OpportunityListMineContainer } from "components/opportunities/redux/OpportunityContainers"
import Icon from "components/common/Icon"

const OpportunityCardMineBasic = () => {
    return (
        <Card>
            <CardHeader>
                <h6>
                    <Icon opportunity />
                    My Opportunities
                </h6>
            </CardHeader>
            <CardBody>
                <OpportunityListMineContainer />
            </CardBody>
        </Card >
    )
}

export default OpportunityCardMineBasic
